import React, { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import useTapToRefresh from '../Hooks/useTapToRefresh'
import { t } from '../i18n'
import FeedList from './FeedList'
import { RefreshRow } from './FeedStatus'
import SortTabs from './SortTabs'

/* ?prikaz=najnovije selects the "Najnovije" tab; "Najčitanije" is the default. */
export function useSortParam() {
  const [params, setParams] = useSearchParams()
  const sort = params.get('prikaz') === 'najnovije' ? 'new' : 'top'
  const setSort = useCallback(
    (value) => {
      const next = new URLSearchParams(params)
      if (value === 'new') next.set('prikaz', 'najnovije')
      else next.delete('prikaz')
      setParams(next, { replace: true })
    },
    [params, setParams]
  )
  return [sort, setSort]
}

/* Sticky tabs + feed of a topic, source, category or search (spec 5.6). */
export default function SortedFeed({ feed, sort, setSort, from, empty, hideTopic, daySeparators }) {
  const { row, tap } = useTapToRefresh(feed)
  return (
    <>
      <div className="sticky-bar sticky-under-header">
        <SortTabs value={sort} onChange={setSort} onReselect={tap} />
      </div>
      <RefreshRow state={row} />
      <FeedList
        ads={false}
        feed={feed}
        from={from}
        empty={empty}
        hideTopic={hideTopic}
        daySeparators={daySeparators}
      />
    </>
  )
}

export function NotFoundMessage({ text }) {
  return (
    <div className="feed-message">
      <p>{text || t('notFound.title')}</p>
    </div>
  )
}
